import { FC } from 'react';
import Box from 'yoda-ui/components/Box';
import { TagCommon } from 'yoda-ui/components/Tags/Tags.types';
import { YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

type TagProps = TagCommon & {
  color?: string;
  fitContent?: boolean;
  border?: boolean;
  fontWeight?: YodaFontWeight;
  fontSize?: YodaFontSize;
  lineHeight?: string;
  paddingY?: YodaSpacing | string;
  paddingX?: YodaSpacing;
  width?: string;
  height?: string;
  minHeight?: string;
  borderRadius?: string;
  borderColor?: string;
};

const useTagStyles = (props: TagProps) => ({
  display: props.fitContent ? 'inline' : 'block',
  backgroundColor: props.bgcolor || YodaColors.gray5,
  border: props.border ? `1px solid ${props.borderColor || props.color}` : '',
  minHeight: props.minHeight || null,
  lineHeight: props.lineHeight || null,
});

const Tag: FC<TagProps> = ({ children, color, fontWeight, fontSize, paddingX, paddingY, borderRadius, ...rest }) => {
  const style = useTagStyles({ ...rest, color });
  return (
    <Box
      borderRadius={ borderRadius || YodaBorderRadius.small }
      sx={ style }
      color={ color || YodaColors.white }
      display="flex"
      fontWeight={ fontWeight || YodaFontWeight.light }
      fontSize={ fontSize || YodaFontSize.medium }
      justifyContent="center"
      paddingX={ paddingX || YodaSpacing.xxSmall }
      paddingY={ paddingY || YodaSpacing.xxSmall }
    >
      { children }
    </Box>
  );
};

export default Tag;
